import React                   from 'react';

class Dialer extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		window.location.href = "https://dialer.internal.instylesolar.com";
	}

	render() {
		return (
			<div className="content">
				<h2>Redirecting to dialer.internal.instylesolar.com</h2>
			</div>
		);
	}
}

export default Dialer;
